// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';

import Vietnam from '../_raw/flag/icon_flag_vietnam.png';

export default () => <img src={Vietnam} alt="Vietnam" />;
